import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import {observer} from 'mobx-react';
import take from 'ramda/src/take';

const INITIAL_ITEMS = 12;
const ITEMS_TO_LOAD = 4;
const isBottom = (el) => el.getBoundingClientRect().bottom <= window.innerHeight;

class Scroller extends Component {
  state = {
    loadItems: INITIAL_ITEMS
  };

  componentDidMount() {
    document.addEventListener('scroll', this.checkScroll);
  }

  componentWillUnmount() {
    document.removeEventListener('scroll', this.checkScroll);
  }

  checkScroll = () => {
    const wrappedElement = document.getElementById('tabs-container');
    if (isBottom(wrappedElement)) {
      this.setState(({loadItems}) => ({
        loadItems: loadItems + ITEMS_TO_LOAD
      }));
    }
  };

  render() {
    return (
      <Fragment>
        {take(this.state.loadItems, this.props.children)}
      </Fragment>
    );
  }
}

Scroller.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired
};

export default observer(Scroller);
